import React from 'react';
import PropTypes from 'prop-types';
import PrimaryLogoDark from '@assets/images/logos/primary_dark.png';
import PrimaryLogoLight from '@assets/images/logos/primary_light.png';
import './styles/primary_logo_link';

export default class PrimaryLogoLink extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }

  logo() {
    if (this.props.theme === 'dark') {
      return PrimaryLogoDark;
    }
    return PrimaryLogoLight;
  }

  render() {
    return (
      <div className="primary-logo-link-component">
        <a
          href="https://brandfolder.com"
          className="primary-logo-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={this.logo()} alt="Brandfolder" />
        </a>
      </div>
    );
  }
}

PrimaryLogoLink.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark'])
};

PrimaryLogoLink.defaultProps = {
  theme: 'dark'
};
